/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sad_Factual_Hare_MopInputs */

const en_sad_factual_hare_mop = /** @type {(inputs: Sad_Factual_Hare_MopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fee`)
};

/**
* | output |
* | --- |
* | "Fee" |
*
* @param {Sad_Factual_Hare_MopInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sad_factual_hare_mop = /** @type {((inputs?: Sad_Factual_Hare_MopInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sad_Factual_Hare_MopInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sad_factual_hare_mop(inputs)
});